































import Vue from 'vue';
import axios from 'axios';
import AddEditFillerTemplate from '../components/AddEditFillerTemplate.vue';
import CreateFillerPDF from '../components/CreateFillerPDF.vue';
import ConfirmDelete from '../components/ConfirmDelete.vue';
import { buildPagination } from '../utils/pagination';

export default Vue.extend({
    name: 'Filler',
    components: { CreateFillerPdf: CreateFillerPDF, AddEditFillerTemplate, ConfirmDelete },
    data() {
        return {
            templates: [],
            currentPageNum: 1 as number,
            numItems: 10,
            pagination: [] as (number | '...')[],
            showAddEditFiller: false,
            showCreatePDF: false,
            showConfirmDelete: false,
            fillerToEdit: 'new',
            fillerToCreate: '',
            fillerToDelete: '',
            isCloning: false
        }
    },
    created() {
        this.getTemplates()
            .then(() => {
                this.$store.state.routeLoaded = true;
            });
    },
    methods: {
        async getTemplates() {
            const url = `${this.$store.state.apiUrl}/filler/templates?pageNum=${this.currentPageNum}&numItems=${this.numItems}`;
            await axios.get(url)
                .then(resp => {
                    this.templates = resp.data.templates;
                    const totalPages = Math.ceil(resp.data.totalRows / this.numItems);
                    this.pagination = buildPagination(this.currentPageNum, totalPages);
                })
                .catch(e => {
                    console.log(e.response?.data);
                });
        },
        changePage(num: number) {
            this.currentPageNum = num;
            this.getTemplates();
        },
        addTemplate() {
            if(this.$store.state.tier != 2) {
                alert('The Form Filler is a Premium feature. Upgrade your plan to Premium to gain access.');
                this.$router.push('/payment');
                return;
            }
            this.fillerToEdit = 'MB_NEW';
            this.isCloning = false;
            this.showAddEditFiller = true;
        },
        editTemplate(name: string) {
            this.fillerToEdit = name;
            this.isCloning = false;
            this.showAddEditFiller = true;
        },
        cloneTemplate(name: string) {
            this.fillerToEdit = name;
            this.isCloning = true;
            this.showAddEditFiller = true;
        },
        closeAddEditFiller() {
            this.showAddEditFiller = false;
            this.currentPageNum = 1;
            this.getTemplates();
        },
        confirmDelete(name: string) {
            this.showConfirmDelete = true;
            this.fillerToDelete = name;
        },
        confirmDeleteTemplate() {
            this.showConfirmDelete = false;
            axios.delete(this.$store.state.apiUrl + '/filler/template/' + encodeURIComponent(this.fillerToDelete))
                .then(resp => {
                    alert('Template deleted.');
                    this.currentPageNum = 1;
                    this.getTemplates();
                })
                .catch(e => {
                    alert('There was an error.')
                })
        },
        cancelDeleteTemplate() {
            this.showConfirmDelete = false;
        },
        createPDF(name: string) {
            this.fillerToCreate = name;
            this.showCreatePDF = true;
        },
        closeCreatePDF() {
            this.showCreatePDF = false;
        },
    }
})
